import { render, staticRenderFns } from "./TradesModern.vue?vue&type=template&id=6cd6a4e4&"
import script from "./TradesModern.vue?vue&type=script&lang=js&"
export * from "./TradesModern.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports